import PageBuilderDispatcher from '../dispatcher/PageBuilderDispatcher';
import PageBuilderConstants from '../constants/PageBuilderConstants';
import PageBuilderActions from '../actions/PageBuilderActions';


var objectAssign = require('object-assign');
var EventEmitter = require('events').EventEmitter.prototype;

var _state = {
  name: '',
  rows: [],
  mode: 'compose',
  charts: [],
  lastId: null,
  activeRowId: null,
  activeTab: 'general',
  activeColumnId: null,
  openMenuRowId: null,
  resizeRowId: null,
  highlightRowId: null,
  highlightColumnId: null,
  redactor: null,
  paths: {},
  // forms: {},
  // textVariables: {},
  // accommodations: [],
  form_field_id: 'page_body',
  forceUpdate: false,
  widgets: [],
};

var PageBuilderStore = objectAssign({}, EventEmitter, {

  /**
  * Event Listener, Event Emitter
  */

  emitChange: function () {
    this.emit(PageBuilderConstants.CHANGE_EVENT);
    _state.forceUpdate = false;
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(PageBuilderConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(PageBuilderConstants.CHANGE_EVENT, callback);
  },

  /**
  * Helpers
  */

  /*
  * Initializes the store merging the options
  *
  * @param {object} opts
  */
  init: function (opts) {
    objectAssign(_state, opts);
    if (_state.rows === null || _state.rows.length === 0) {
      _state.rows = [];
      _state.rows.push(this.createRow()); // there should always be one row
    }
    // console.log('in init', _state.rows)
    /* global functions */
    window._insertImages = PageBuilderStore._insertImages;
    window._insertTextVariables = PageBuilderStore._insertTextVariables;
  },

  /**
  * Adds a column to the left or right (the beginning or end) of the row id passed in
  *
  * @params {string} id
  * @params {string} direction ('left' or 'right')
  */
  addColumn: function (id, direction) {
    var row = this.getRow(id);

    if (row.columns.length < 6) {
      var newColumn = this.createColumn(row);

      this.makeRoom(row, direction);
      row.columns.splice((direction === PageBuilderConstants.LEFT ? 0 : row.columns.length), 0, newColumn);

      return newColumn.id;
    } else {
      // no op - you can't have more than 12 rows
    }
  },

  /**
  * Adds a row above or below the row id passed in
  *
  * @param {string} id
  * @param {string} direction ('above' or 'below')
  *
  * @returns {string} newRowId
  */
  addRow: function (id, direction) {
    var idx = direction === PageBuilderConstants.ABOVE ? this.getRowIndex(id) : this.getRowIndex(id) + 1,
        newRow = this.createRow();

    _state.rows.splice(idx, 0, newRow);

    return newRow.id;
  },

  /**
  * Ensures there's always a blank last row
  */
  blankLastRow: function () {
    if (_state.rows.length === 0) {
      _state.rows.push(PageBuilderStore.createRow()); // there should always be one row
    }/* else {
      var lastRow = _state.rows[_state.rows.length - 1];

      if (this.hasContent(lastRow)) {
        _state.rows.push(PageBuilderStore.createRow());
      }
    }*/
  },

  /**
  * Creates a blank column object
  *
  * @param {object} row
  * @returns {object}
  */
  createColumn: function (row) {
    var nextColumnId = this.nextColumnId(row);

    return {
      id: row.id + '_c' + nextColumnId,
      content: '',
      size: row.columns.length ? 2 : 12
    }
  },

  /**
  * Creates a blank row object
  *
  * @returns {object}
  */
  createRow: function () {
    var row = {id: 'r' + this.nextRowId(), columns: []},
        column = this.createColumn(row);

    row.columns.push(column);

    return row;
  },

  /*
  * @param {string} rowId
  * @param {string} columnId
  */
  deleteColumn: function (rowId, columnId) {
    var row = this.getRow(rowId);

    if (row.columns.length === 1) {
      // if a row only has one column, delete entire row
      this.deleteRow(rowId);
    } else {
      // delete this column only
      var columnIndex = this.getColumnIndex(row, columnId);
      var columnSize = this.getColumn(row, columnId).size;

      row.columns.splice(columnIndex, 1);
      this.resizeColumn(rowId, row.columns[0].id, PageBuilderConstants.UP, columnSize);
    }
  },

  /**
  * @param {string} id
  */
  deleteRow: function (id) {
    var idx = this.getRowIndex(id);
    _state.rows.splice(idx, 1);
  },

  disablePageButtons: function () {
    $('.page-buttons').addClass('disabled'); //TODO: Make this more dynamic
  },

  /**
  * Duplicates a row (now, with ZERO looping)
  *
  * @param {string} id
  *
  * @return {string} newRowId
  */
  duplicateRow: function (id) {
    var oldRow = this.getRow(id),
        index = this.getRowIndex(id),
        nextRowId = 'r' + this.nextRowId(),
        newRow = JSON.parse(JSON.stringify(oldRow).replace(oldRow.id, nextRowId));

    _state.rows.splice(index + 1, 0, newRow);

    return newRow.id;
  },

  enablePageButtons: function () {
    $('.page-buttons').removeClass('disabled'); //TODO: Make this more dynamic
  },

  /**
  * @return {object} row
  */
  getActiveColumn: function () {
    return this.getColumn(this.getRow(_state.activeRowId), _state.activeColumnId);
  },

  getActiveTab: ()=>_state.activeTab,

  getCharts: function () {
    return _state.charts;
  },

  /**
  * @param {object} row
  * @param {string} id
  * @return {object} column
  */
  getColumn: function (row, id) {
    for (var i = 0, ilen = row.columns.length; i < ilen; i++) {
      if (row.columns[i].id === id) {
        return row.columns[i];
      }
    }
  },

  /**
  * @param {object} row
  * @param {string} id
  * @return {integer}
  */
  getColumnIndex: function (row, id) {
    for (var i = 0, ilen = row.columns.length; i < ilen; i++) {
      if (row.columns[i].id === id) {
        return i;
      }
    }
  },

  /**
  * Gets the integer portion of a row (r1) or column (r1_c1) id
  *
  * @param {string} id
  * @return {integer}
  */
  getIntegerId: function (id) {
    id = id.substring(1);

    // column ids will have an '_c'
    if (id.indexOf('_c') !== -1) {
      id = id.split('_c')[1];
    }

    return parseInt(id, 10);
  },

  /**
  * @return {object} row
  */
  getActiveRow: function () {
    return this.getRow(_state.activeRowId);
  },

  getName: function () {
    return _state.name;
  },
  
  getRoleIds: function() {
    return _state.role_ids;
  },

  /**
  * @param {string} id
  * @return {object} row
  */
  getRow: function (id) {
    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      if (_state.rows[i].id === id) {
        return _state.rows[i];
      }
    }
  },

  /**
  * @param {string} id
  * @return {integer} index
  */
  getRowIndex: function (id) {
    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      if (_state.rows[i].id === id) {
        return i;
      }
    }
  },

  getWidgets: function () {
    return _state.widgets;
  },

  /**
  * @param {object} row
  * @returns {boolean}
  */
  hasContent: function (row) {
    for(var column in row.columns) {
      if (row.columns[column].content !== '') {
        return true;
      }
    }

    return false;
  },

  /**
  * @param {string} id
  */
  flashColumn: function (id) {
    $('#' + id).find('.editorWrapper').effect('highlight', {color: '#FF6600'});
  },

  /**
  * @param {string} id
  */
  flashRow: function (id) {
    $('#' + id).find('.column .editorWrapper').effect('highlight', {color: '#FF6600'});
  },

  /**
  * Makes room in the row to add a new column (of size 1)
  *
  * @param {object} row
  * @param {string} direction
  */
  makeRoom: function (row, direction) {

    if (direction === PageBuilderConstants.RIGHT) {
      //iterate over array in reverse
      for (var i = row.columns.length - 1; i >= 0; i--) {
        var column = row.columns[i];
        if (column.size > 2) {
          column.size = column.size - 2;
          break;
        }
      }
    } else if (direction === PageBuilderConstants.LEFT) {
      for (var i = 0, ilen = row.columns.length; i < ilen; i++) {
        var column = row.columns[i];
        if (column.size > 2) {
          column.size = column.size - 2;
          break;
        }
      }
    }
  },

  /**
  * Moves a row up or down
  *
  * @param {string} id
  * @param {string} direction ('up' or 'down')
  */
  moveRow: function (id, direction) {
    var row = this.getRow(id),
        index = this.getRowIndex(id),
        newIndex = index + (direction === PageBuilderConstants.UP ? -1 : 1);

    if (direction === PageBuilderConstants.UP) {
      if (newIndex < 0) {
        newIndex = 0
      }
    } else if (direction === PageBuilderConstants.DOWN) {
      if (newIndex > _state.rows.length) {
        newIndex = _state.rows.length;
      }
    }

    _state.rows.splice(index, 1);
    _state.rows.splice(newIndex, 0, row);
  },

  /**
  * Generates and returns the next available column id
  *
  * @param {object} row
  * @return {integer}
  */
  nextColumnId: function (row) {
    var id = 0;

    for (var i = 0, ilen = row.columns.length; i < ilen; i++) {
      var columnId = this.getIntegerId(row.columns[i].id);

      if (columnId > id) {
        id = columnId;
      }
    }

    return ++id;
  },

  /**
  * Generates and returns the next available row id
  *
  * @return {integer}
  */
  nextRowId: function () {
    if (_state.lastId === null) {
      _state.lastId = 0;
      for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
        var id = this.getIntegerId(_state.rows[i].id);
        if (_state.lastId < id) {
          _state.lastId = id;
        }
      }
    }

    return ++_state.lastId;
  },

  /**
  * Resizes a column
  *
  * @param {string} rowId
  * @param {string} columnId
  * @param {string} direction ('up' or 'down')
  * @param {integer} amount (default 1)
  */
  resizeColumn: function (rowId, columnId, direction, amount) {
    // console.log('resizeColumn', rowId, columnId, direction, amount)
    var row = this.getRow(rowId),
        column = this.getColumn(row, columnId),
        amount = amount || 1;

    if (direction === PageBuilderConstants.UP) {
      if (parseInt(column.size) < 12) {
        column.size = parseInt(column.size) + amount;
      }
    } else if (direction === PageBuilderConstants.DOWN) {
      if (parseInt(column.size) > 1) {
        column.size = parseInt(column.size) - amount;
      }
    }
  },

  resetColumn: function (rowId, columnId) {
    var updated = false;

    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      var row = _state.rows[i];

      if (row.id === rowId) {
        for (var j = 0, jlen = row.columns.length; j < jlen; j++) {
          var column = row.columns[j];

          if (column.id == columnId) {
            column.content_type = null;
            column.content = null;
            column.chart_id = null;
            column.widget_id = null;
            updated = true;
            break;
          }
        }
      }

      if (updated) {
        break;
      }
    }
  },

  setName: function (name) {
    _state.name = name;
  },

  setChart: function (rowId, columnId, chartId) {
    var updated = false;
    // console.log('setChart', rowId, columnId, chartId)
    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      var row = _state.rows[i];

      if (row.id === rowId) {
        for (var j = 0, jlen = row.columns.length; j < jlen; j++) {
          var column = row.columns[j];

          if (column.id == columnId) {
            // console.log('setting chart id!', chartId)
            column.chart_id = chartId;
            updated = true;
            break;
          }
        }
      }

      if (updated) {
        break;
      }
    }
  },

  changeTab: function(tab) {
    _state.activeTab = tab;
  },
  
  changeRoles: function(roles) {
    _state.role_ids = roles;
  },

  setWidget: function (rowId, columnId, widgetId) {
    var updated = false;
    // console.log('setWidget', rowId, columnId, widgetId)
    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      var row = _state.rows[i];

      if (row.id === rowId) {
        for (var j = 0, jlen = row.columns.length; j < jlen; j++) {
          var column = row.columns[j];
          // console.log('column.id', columnId, column.id)
          if (column.id == columnId) {
            // console.log('setting widget id', widgetId)
            column.widget_id = widgetId;
            updated = true;
            break;
          }
        }
      }

      if (updated) {
        break;
      }
    }
  },

  setContentType: function (rowId, columnId, contentType) {
    var updated = false;
    
    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      var row = _state.rows[i];
      
      if (row.id === rowId) {
        for (var j = 0, jlen = row.columns.length; j < jlen; j++) {
          var column = row.columns[j];
          
          if (column.id == columnId) {
            column.content_type = contentType;
            updated = true;
            break;
          }
        }
      }
      
      if (updated) {
        break;
      }
    }
  },

  /**
  * Updates a column's styling definition
  *
  * @param {string} rowId
  * @param {string} columnid
  * @param {object} style
  */
  styleColumn: function (rowId, columnId, style) {
    var row = this.getRow(rowId),
        column = this.getColumn(row, columnId);

    column.style = objectAssign(column.style || {}, style);
  },

  /**
  * Toggles a row's device visibility
  *
  * @param {string} id
  * @param {string} device
  */
  toggleVisibility: function (id, device) {
    var row = this.getRow(id);

    row['hideOnDevice'] = typeof row['hideOnDevice'] !== 'undefined' ? row['hideOnDevice'] : {};
    row['hideOnDevice'][device] = typeof row['hideOnDevice'][device] !== 'undefined' ? !row['hideOnDevice'][device] : true;
  },

  /**
  * Updates a form input with the current stringified row content
  */
  updateFormFieldContent: function () {
    // document.getElementById(_state.form_field_id).value = JSON.stringify(_state.rows);
  },

  /**
  * Updates column content
  */
  updateColumnContent: function (rowId, columnId, content) {
    var updated = false;
    // console.log('updateColumnContent', rowId, columnId, content)
    for (var i = 0, ilen = _state.rows.length; i < ilen; i++) {
      var row = _state.rows[i];

      if (row.id === rowId) {
        for (var j = 0, jlen = row.columns.length; j < jlen; j++) {
          var column = row.columns[j];

          if (column.id == columnId) {
            column.content = content;
            updated = true;
            break;
          }
        }
      }

      if (updated) {
        break;
      }
    }
  },

  /**
  * Utility Functions
  */
  _insertImages: function (images) {
    if (_state.redactor && _state.redactor.insert && _state.redactor.insert.html) {
      _state.redactor.insert.html(images);
    }
  },

  _insertTextVariables: function (textVariables) {
    if (_state.redactor && _state.redactor.insert && _state.redactor.insert.html) {
      _state.redactor.insert.html(textVariables);
    }
  },

  // _insertForm: function (name) {
  //   if (_state.redactor && _state.redactor.insert && _state.redactor.insert.html) {
  //     var col = this.getActiveColumn();

  //     console.log('insertForm', _state.activeColumnId, _state.activeRowId, col)

  //     _state.redactor.insert.html('FORM', false);
  //   }
  // },

  /**
  * Getters
  */

  getAccommodations: function () {
    return _state.accommodations;
  },

  getForms: function () {
    return _state.forms;
  },

  getTextVariables: function () {
    return _state.textVariables;
  },

  getMode: function () {
    return _state.mode;
  },

  getRows: function () {
    return _state.rows;
  },

  getActiveRowId: function () {
    return _state.activeRowId;
  },

  getActiveColumnId: function () {
    return _state.activeColumnId;
  },

  getOpenMenuRowId: function () {
    return _state.openMenuRowId;
  },

  getResizeRowId: function () {
    return _state.resizeRowId;
  },

  getHighlightRowId: function () {
    return _state.highlightRowId;
  },

  getHighlightColumnId: function () {
    return _state.highlightColumnId;
  },

  getForceUpdate: function () {
    return _state.forceUpdate;
  }

});

PageBuilderStore.dispatchToken = PageBuilderDispatcher.register(function (payload) {

  // console.log('PageBuilderStore has received a payload from the Dispatcher', payload);

  switch (payload.action) {

    case PageBuilderConstants.INIT:
      PageBuilderStore.init(payload.opts);
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.CHANGE_MODE:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.activeRowId = null;
      _state.activeColumnId = null;
      _state.highlightRowId = null;
      _state.highlightColumnId = null;
      _state.mode = payload.name;
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.FOCUS_EDITOR:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.activeRowId = payload.rowId;
      _state.activeColumnId = payload.columnId;
      _state.highlightRowId = null;
      _state.highlightColumnId = payload.columnId;
      PageBuilderStore.disablePageButtons();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.BLUR_EDITOR:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.activeRowId = null;
      _state.activeColumnId = null;
      _state.highlightColumnId = null;
      _state.highlightRowId = null;
      PageBuilderStore.updateColumnContent(payload.rowId, payload.columnId, payload.content);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.enablePageButtons();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.SAVE_EDITOR:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.activeRowId = null;
      _state.activeColumnId = null;
      _state.highlightColumnId = null;
      _state.highlightRowId = payload.rowId;
      PageBuilderStore.updateColumnContent(payload.rowId, payload.columnId, payload.content);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.enablePageButtons();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.SET_CONTENT_TYPE:
      PageBuilderStore.setContentType(payload.rowId, payload.columnId, payload.contentType);
      PageBuilderStore.emitChange();
      break

    case PageBuilderConstants.SET_NAME:
      PageBuilderStore.setName(payload.name);
      PageBuilderStore.emitChange();
      break

    case PageBuilderConstants.CHANGE_TAB:
      PageBuilderStore.changeTab(payload.tab);
      PageBuilderStore.emitChange();
      break

    case PageBuilderConstants.CHANGE_ROLES:
      PageBuilderStore.changeRoles(payload.roles);
      PageBuilderStore.emitChange();
      break

    case PageBuilderConstants.SET_CHART:
      PageBuilderStore.setChart(payload.rowId, payload.columnId, payload.chartId);
      PageBuilderStore.emitChange();
      break

    case PageBuilderConstants.SET_WIDGET:
      PageBuilderStore.setWidget(payload.rowId, payload.columnId, payload.widgetId);
      PageBuilderStore.emitChange();
      break

    case PageBuilderConstants.ADD_COLUMN:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.highlightRowId = null;
      var newColumnId = PageBuilderStore.addColumn(payload.rowId, payload.direction);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      setTimeout(PageBuilderStore.flashColumn.bind(null, newColumnId), 0);
      break;

    case PageBuilderConstants.ADD_ROW:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.highlightRowId = null;
      var newRowId = PageBuilderStore.addRow(payload.rowId, payload.direction);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      setTimeout(PageBuilderStore.flashRow.bind(null, newRowId), 0);
      break;

    case PageBuilderConstants.DELETE_COLUMN:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.forceUpdate = true;
      PageBuilderStore.deleteColumn(payload.rowId, payload.columnId);
      PageBuilderStore.blankLastRow();
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.DELETE_ROW:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.forceUpdate = true;
      PageBuilderStore.deleteRow(payload.rowId);
      PageBuilderStore.blankLastRow();
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.RESET_COLUMN:
      PageBuilderStore.resetColumn(payload.rowId, payload.columnId);
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.DUPLICATE_ROW:
      if ($('[data-form]').length) {
        alert(I18n.t('only_one_form_per_page_allowed'));
        return;
      }
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.highlightRowId = null;
      var newRowId = PageBuilderStore.duplicateRow(payload.rowId);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      setTimeout(PageBuilderStore.flashRow.bind(null, newRowId), 0);
      break;

    case PageBuilderConstants.HIGHLIGHT_COLUMN:
      _state.highlightColumnId = payload.columnId;
      _state.highlightRowId = payload.rowId;
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.HIGHLIGHT_ROW:
      if (payload.rowId === null && _state.openMenuRowId !== null) {
        break;
      }
      _state.highlightRowId = payload.rowId;
      PageBuilderStore.emitChange();
      break;

    // case PageBuilderConstants.INSERT_IMAGES:
    //   _state.redactor = payload.redactor;
    //   window.dialog(_state.paths.insert_images, true);
    //   break;

    // case PageBuilderConstants.INSERT_TEXT_VARIABLES:
    //   _state.redactor = payload.redactor;
    //   window.dialog(_state.paths.insert_text_variables, true);
    //   break;

    // case PageBuilderConstants.INSERT_FORM:
    //   $(window).off('click.rowmenu');
    //   var activeColumn = PageBuilderStore.getActiveColumn();
    //   activeColumn.content = payload.name;
    //   _state.openMenuRowId = null;
    //   _state.activeRowId = null;
    //   _state.activeColumnId = null;
    //   _state.highlightedRowId = null;
    //   _state.highlightColumnId = null;
    //   PageBuilderStore.updateFormFieldContent();
    //   PageBuilderStore.enablePageButtons();
    //   PageBuilderStore.emitChange();
    //   break;

    case PageBuilderConstants.MOVE_ROW:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.highlightRowId = null;
      PageBuilderStore.moveRow(payload.rowId, payload.direction);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      setTimeout(PageBuilderStore.flashRow.bind(null, payload.rowId), 0);
      break;

    case PageBuilderConstants.RESIZE_COLUMN:
      PageBuilderStore.resizeColumn(payload.rowId, payload.columnId, payload.direction);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.RESIZE_ROW:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      _state.resizeRowId = payload.rowId;
      payload.rowId === null ? PageBuilderStore.enablePageButtons() : PageBuilderStore.disablePageButtons();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.STYLE_COLUMN:
      PageBuilderStore.styleColumn(payload.rowId, payload.columnId, payload.style);
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.TOGGLE_VISIBILITY:
      PageBuilderStore.toggleVisibility(payload.rowId, payload.device);
      PageBuilderStore.updateFormFieldContent();
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.OPEN_ROW_MENU:
      $(window).on('click.rowmenu', function () { _state.highlightRowId = null; PageBuilderActions.closeRowMenu(); });
      _state.openMenuRowId = payload.rowId;
      _state.highlightRowId = payload.rowId;
      PageBuilderStore.emitChange();
      break;

    case PageBuilderConstants.CLOSE_ROW_MENU:
      $(window).off('click.rowmenu');
      _state.openMenuRowId = null;
      PageBuilderStore.emitChange();
      break;

    default:
      // no op
  }

});

/* silence the EventEmitter */
PageBuilderStore.setMaxListeners(0);

export default PageBuilderStore
